(()=>{
  const form = document.querySelector('form');
  const errorContainer = document.querySelector('.error-container');
  let errorMessages = [];

  form.addEventListener('submit', (event) => {
    event.preventDefault(); // Prevent default form submission
    errorMessages = [];

    // Validate name
    const nameInput = document.getElementById('from-name');
    if (!nameInput.value.trim()) {
      errorMessages.push('Please enter your name.');
    }

    // Validate email
    const emailInput = document.getElementById('from-email');
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(emailInput.value)) {
      errorMessages.push('Please enter a valid email address.');
    }

    // Validate enquiry type
    const enquiryTypeInput = document.getElementById('enquiryType');
    if (enquiryTypeInput.value === '') {
      errorMessages.push('Please select an enquiry type.');
    }

    // Validate region
    const regionInput = document.getElementById('region');
    if (regionInput.value === '') {
      errorMessages.push('Please select a region.');
    }

    // Validate message
    const messageInput = document.getElementById('message');
    if (!messageInput.value.trim()) {
      errorMessages.push('Please enter a message.');
    }

    // Show errors if any
    if (errorMessages.length > 0) {
      errorContainer.classList.remove('hidden');
      errorContainer.innerHTML = errorMessages.join('<br>');
      return;
    }

    // Submit form if no errors
    if (errorMessages.length === 0) {
      const formAction = document.querySelector('input[name="action"]');
      form.action = formAction.value;
      form.submit();
    }
  });

})();
